import React, { Component } from 'react';
import { Provider } from 'react-redux';
import Routes from './routes/Routes';
import { Store } from 'redux';
import { History } from 'history';
import { ConnectedRouter } from 'connected-react-router';

export default class Root extends Component<RootProps> {

    render() {
        const { store, history } = this.props;

        return (
            <Provider store={store}>
                <ConnectedRouter history={history}>
                    <Routes/>
                </ConnectedRouter>
            </Provider>
        );
    }
}


interface RootProps {
    store: Store;
    routes: React.ComponentType;
    history: History
}
